import { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import mixpanel from 'mixpanel-browser';

export const useToaster = (ref, ComponentToRender, toastId) => {
  const hasShownRef = useRef(false);

  useEffect(() => {
    if (!ref?.current || hasShownRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasShownRef.current) {
          toast(ComponentToRender, {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: false,
            toastId: toastId,
            theme: 'light',
            onClose: () => {
              mixpanel.track('Survey from Toaster ', {
                path: `${window?.location?.pathname}`,
                clicked: 'Close Button',
              });
            },
          });

          hasShownRef.current = true;
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px',
      },
    );

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref, ComponentToRender, toastId]);
};
